import {
  SlDetails
} from "./chunk.PRPR3HH4.js";

// src/components/details/details.ts
var details_default = SlDetails;
SlDetails.define("sl-details");

export {
  details_default
};
